// ─── Shipping option display helpers (docs page + client portal) ─────
// Pure, browser-safe formatting for serializeShippingOption() output.

export function formatCents(cents) {
  return cents === 0 ? "Free" : `$${(cents / 100).toFixed(2)}`;
}

// "$9.95 up to a $100.00 order · Free from $100.00"
export function formatShippingPriceRule(prices) {
  if (!Array.isArray(prices) || prices.length === 0) return "—";
  if (prices.length === 1 && !prices[0].minOrderTotalCents && prices[0].maxOrderTotalCents == null) {
    return formatCents(prices[0].priceCents);
  }
  return prices
    .map((p) => {
      const price = formatCents(p.priceCents);
      if (p.maxOrderTotalCents != null && !p.minOrderTotalCents) {
        return `${price} up to a ${formatCents(p.maxOrderTotalCents)} order`;
      }
      if (p.maxOrderTotalCents == null) return `${price} from ${formatCents(p.minOrderTotalCents)}`;
      return `${price} for ${formatCents(p.minOrderTotalCents)}–${formatCents(p.maxOrderTotalCents)}`;
    })
    .join(" · ");
}

// "UPS Ground (1-3 Days Delivery)" → { service: "UPS Ground", estimate: "1–3 days" }
export function splitServiceName(name) {
  const text = String(name || "");
  const match = text.match(/\(([^)]*)\)/);
  const service = text.replace(/\([^)]*\)/g, "").trim() || text;
  const estimate = match
    ? match[1].replace(/\bdelivery\b/i, "").replace(/(\d)\s*-\s*(\d)/, "$1–$2").trim().toLowerCase()
    : "";
  return { service, estimate };
}

// Public tracking page for the carriers we ship with.
export function trackingUrl(carrier, number) {
  if (!number) return null;
  const c = String(carrier || "").toLowerCase();
  const n = encodeURIComponent(number);
  if (c.includes("ups") || /^1Z/i.test(number)) return `https://www.ups.com/track?tracknum=${n}`;
  if (c.includes("fedex")) return `https://www.fedex.com/fedextrack/?trknbr=${n}`;
  if (c.includes("usps") || c.includes("stamps")) return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${n}`;
  return null;
}
